<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
.margin-bottom-filtro {
  margin-bottom: 15px !important;
}

.swal-funcionalidade-bloqueada {
  padding: 28px 32px 24px;
  text-align: center;
}

.swal-funcionalidade-bloqueada .swal-title {
  color: #5f0909;
  font-size: 21px;
  margin-bottom: 10px;
}

.swal-funcionalidade-bloqueada .swal-text {
  color: #333;
  font-size: 15px;
  line-height: 1.5;
  margin: 0 auto;
  max-width: 380px;
  text-align: center;
}

.swal-funcionalidade-bloqueada .swal-footer {
  margin-top: 22px;
  padding-top: 0;
  text-align: center;
}

.swal-funcionalidade-bloqueada .swal-button {
  background-color: #a40d07;
  border-radius: 6px;
  min-width: 92px;
}

.swal-funcionalidade-bloqueada .swal-button:not([disabled]):hover {
  background-color: #870b06;
}
</style>



// WEBPACK FOOTER //
// src/App.vue